import React, { useContext } from "react";
import { ParagraphConnector } from "../../components/Paragraph";
import { RCLContext } from "../../components/RCL/RCLProvider";
import styles from "./LandingPageVwq.module.scss";
import { VWQIcon } from "@sunwing/icons";

const PromptCardGrid = ({ PromptCards }) => {
  const { locale } = useContext(RCLContext);

  return (

    <div className={styles.gridContainer}>
      {PromptCards.map((card, index) => (
        <>
        <div key={index} className={styles.flyerPromptContainer}>
          <div className={styles.flyerPromptImageContainer}>
              {(card.image && card.image[0]?.url) ? 
                (<img src={card.image?card.image[0]?.url:''}
                  alt="placeholder alt"
                  className={styles.flyerPromptImage}
                />):
                ( <VWQIcon name="fee-micro" className={styles.flyerPromptIcon} />)
              }
          </div>
          <div className={styles.flyerPromptContentContainer}>
              {card.content && (
                    <ParagraphConnector
                    data={card.content}
                    locale={locale === "fr" ? locale : "en-CA"}
                  />
              )}
          </div>
        </div>
        </>
  
      ))}
    </div>
  );
};

export default PromptCardGrid;